import React, { Component } from 'react'
import './air-conditioner-fee.less'
import { setHeader } from '@/util/set-header'
import { List, Toast, Stepper } from 'antd-mobile'
import SelectPay from '../common/select-pay/select-pay'
import Checkbox from '@/components/checkbox/checkbox'
import { fetchPayBase } from '@/api/payment'
import PayGroup from '../common/pay-group'
import { connect } from 'react-redux'

const AStepper: any = Stepper
const Item = List.Item

const mapStateToProps = (state: any) => {
  return {
    info: state.payment,
  }
}

@(connect(mapStateToProps) as any)
export default class AirConditionerFee extends Component<any, any> {

  roomData: any = {}
  airFee: any = {}
  airFeeData: any = {}
  constructor(props: any) {
    super(props)
    this.state = {
      bill_cycle_type: 'day',
      val: 1,
      payType: 'alipay',
      store_no: '',
      room_no: '',
      bed_no: '',
      totalPrice: 0.00,
      name: '',
      dayPrice: 0.00,
      monthPrice: 0.00
    }
    this.initData = this.initData.bind(this)
  }
  UNSAFE_componentWillMount() {
    setHeader({ title: '缴费', leftClick: this.closePage.bind(this) })
    Toast.loading('加载中', 0)
  }
  async componentDidMount() {
    const { info } = this.props
    if (info.checkin_id) {
      this.initData(info)
    }
  }
  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.info
    const { info } = this.props
    if (nextInfo.checkin_id === '') {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~', 2, () => {
        if (window.WebViewBridge) {
          window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      })
      return
    }
    if (info.checkin_id !== nextInfo.checkin_id) {
      this.initData(nextInfo)
    }
  }
  async initData(info: any) {
    const { data } = await fetchPayBase(info.checkin_id)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
          window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      })
      return
    }

    this.roomData = data.data.info
    this.airFee = data.data.air_conditioner
    this.airFeeData = data.data.info.air_conditioner_fee_info
    this.setState({
      name: info.name,
      store_no: this.roomData.store_no,
      room_no: this.roomData.room_no,
      bed_no: this.roomData.bed_no,
      bill_cycle_type: (this.airFeeData.day_status) ? 'day' : 'month',
      totalPrice: (this.airFeeData.day_status) ? this.airFeeData.day_price : this.airFeeData.month_price,
      dayPrice: this.airFeeData.day_price,
      monthPrice: this.airFeeData.month_price
    })
  }
  // 增减周期
  onChangeCycle = (val: any) => {
    let step = parseInt(val)
    if (isNaN(step)) {
      step = 1
    }
    this.setState({
      val: step,
      totalPrice:
        this.state.bill_cycle_type === 'day'
          ? this.airFeeData.day_price * step
          : this.airFeeData.month_price * step,
    })
  }

  _handleBlur() {
    window.scroll(0, 0);
  }

  // 支付方式
  payTypeChange = (payType: string) => {
    this.setState({
      payType: payType,
    })
  }

  // 选择日付或者月付
  onSelectDayOrMonth = (cycleType: string) => {
    this.setState({
      bill_cycle_type: cycleType,
      totalPrice: (cycleType === 'day') ?
        this.airFeeData.day_price * this.state.val :
        this.airFeeData.month_price * this.state.val,
    })
  }

  // 传递参数
  loadData = () => {
    return {
      pay_type: this.state.payType,
      cost_data: [
        {
          money: this.state.totalPrice,
          subject_id: this.airFee.subject_id,
          subject_name: this.airFee.subject_name,
          type: this.state.bill_cycle_type,
          cycle: this.state.val,
        },
      ],
    }
  }

  // 关闭当前缴费页
  closePage() {
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }

  render() {
    return (
      <div className="air-conditioner">
        <List>
          <Item extra={<span className="black_cor">{this.state.name}</span>}>缴费人</Item>

          <Item extra={<span className="black_cor">{this.state.store_no + '-' + this.state.room_no + '-' + this.state.bed_no}</span>}>
            房间号
        </Item>

          <Item
            style={{ marginTop: '15px' }}
            extra={<span className="red_cor">中央空调费</span>}
          >
            缴费项目
        </Item>

          <Item extra={<span className="black_cor">{(this.state.bill_cycle_type === 'day') ? '日付' : '月付'}</span>}>计算周期</Item>

          <Item
            className="bag"
            onClick={() => this.onSelectDayOrMonth('day')}
            extra={<Checkbox checked={this.state.bill_cycle_type === 'day'} />}
          >
            日付
        </Item>

          <Item
            className="bag"
            onClick={() => this.onSelectDayOrMonth('month')}
            extra={<Checkbox checked={this.state.bill_cycle_type === 'month'} />}
          >
            月付
        </Item>
          <Item extra={<span className="black_cor">
            {this.state.bill_cycle_type === 'month' ? 
            parseFloat(this.state.monthPrice).toFixed(2) : 
            parseFloat(this.state.dayPrice).toFixed(2)}</span>}>周期单价</Item>
          <Item
            extra={
              <AStepper
                style={{ width: '100%', minWidth: '100px' }}
                showNumber
                min={1}
                value={this.state.val}
                onChange={this.onChangeCycle}
                onBlur={this._handleBlur}
              />
            }
          >
            缴费周期
            </Item>
          <SelectPay payType={this.state.payType} onChange={this.payTypeChange} />

        </List>
        <PayGroup money={this.state.totalPrice} loadData={this.loadData} />
      </div>
    )
  }
}
